module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-faq-accordion"
  }, [_c('div', {
    staticClass: "custom-faq-accordion__container"
  }, [_vm._m(0), _vm._l((_vm.content.item), function(item, i) {
    return _c('div', {
      staticClass: "custom-faq-accordion__tab"
    }, [_c('div', {
      staticClass: "custom-faq-accordion__container--title",
      domProps: {
        "innerHTML": _vm._s(item.title)
      },
      on: {
        "click": function($event) {
          return _vm.showContent(i)
        }
      }
    }), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i === _vm.isOpen),
        expression: "i === isOpen"
      }],
      staticClass: "custom-faq-accordion__container--body",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })])], 1)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-faq-accordion__title"
  }, [_c('h1', [_vm._v("FAQ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2185d1ea","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-faq-accordion/custom-faq-accordion.pug
// module id = 619
// module chunks = 1